/**
 * GIFT4TEE — hai viec dong o trang gio hang:
 *   1. dong ho dem "gio hang se het han sau ..."
 *   2. o vuong ban them (mau: Priority Production) — danh dau la them san pham vao
 *      gio, bo danh dau la xoa khoi gio
 *
 * Script nay nap NGOAI the <hdt-main-cart> (xem cuoi sections/main-cart.liquid).
 * Ly do: CartMain cua theme lam `this.innerHTML = <html section moi>` moi lan gio
 * doi, ma script chen bang innerHTML thi trinh duyet khong chay lai. De ngoai nen
 * no chi nap mot lan, roi tu bat lai DOM moi qua su kien `cart:main:render`.
 *
 * KHONG bao gio tu xoa gio hang khi dong ho ve 0 — het gio chi doi dong chu. Xoa
 * hang cua khach la viec khong duoc phep tu quyet.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* --------------------------------------------------------- 1. dong ho dem */

  var timer = null;
  var deadline = 0;

  function box() {
    return document.querySelector('[data-g4t-expire]');
  }

  /**
   * Moc het han chi tinh MOT lan cho moi lan tai trang, giu trong bien `deadline`
   * cua module (khong luu vao storage). Hai he qua, ca hai deu la co y:
   *
   *   - Tai lai trang / quay lai trang gio => dem lai tu dau. Bien module mat theo
   *     document cu nen tu dong ve 0.
   *   - Doi so luong hay tick o ban them => CartMain ve lai section va ban
   *     `cart:main:render`, startClock() chay lai nhung bien module van con nen
   *     dong ho chay tiep, khong bi giat ve 10:00 giua chung.
   *
   * Truoc day moc nay nam trong sessionStorage nen tai lai trang cung khong reset;
   * bo di vi dong ho nay la loi keo mua, khong phai gio giu hang that — Shopify
   * khong giu ton kho theo no.
   */
  function deadlineOf(minutes) {
    return deadline || Date.now() + minutes * 60000;
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function tick() {
    var el = box();
    if (!el) {
      stop();
      return;
    }
    var left = deadline - Date.now();
    var live = el.querySelector('[data-g4t-expire-live]');
    var over = el.querySelector('[data-g4t-expire-over]');

    if (left <= 0) {
      el.classList.add('is-over');
      if (live) live.hidden = true;
      if (over) over.hidden = false;
      stop();
      return;
    }

    var total = Math.round(left / 1000);
    var mm = Math.floor(total / 60);
    var ss = total % 60;
    var clock = el.querySelector('[data-g4t-clock]');
    if (clock) clock.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
  }

  function startClock() {
    stop();
    var el = box();
    if (!el) return;
    deadline = deadlineOf(Number(el.dataset.minutes) || 10);
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------- 2. o vuong ban them */

  function onChange(event) {
    var input = event.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-g4t-upsell')) return;

    var id = input.getAttribute('data-variant-id');
    if (!id) return;

    var add = input.checked;
    var row = input.closest('.g4t-cart__upsell');
    if (row) row.classList.add('is-busy');

    // /cart/change.js chi sua duoc dong da co trong gio nen them phai dung
    // /cart/add.js; bo thi change.js voi quantity 0 (nhan ca variant id, khong
    // can biet dong thu may).
    var url = root() + (add ? 'cart/add.js' : 'cart/change.js');
    var body = add ? { items: [{ id: Number(id), quantity: 1 }] } : { id: String(id), quantity: 0 };

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error(url + ' ' + response.status);
        // de chinh theme ve lai ca trang gio: dong hang, tam tinh, thanh free ship.
        // Duong nay chay voi source 'reload' nen khong dinh den popup them vao gio.
        document.dispatchEvent(new CustomEvent('cart:reload'));
        // chot chan: neu vi ly do gi ma section khong ve lai thi cung phai mo khoa
        setTimeout(function () {
          if (row) row.classList.remove('is-busy');
        }, 6000);
      })
      .catch(function (error) {
        // that bai thi tra o vuong ve trang thai cu cho khoi lech voi gio thuc te
        input.checked = !add;
        if (row) row.classList.remove('is-busy');
        console.error('[g4t-cart]', error);
      });
  }

  /* ------------------------------------------- 3. anh khoi tin cay bi thieu */

  /**
   * File anh trong assets/ co the chua up len (hoac sai ten) => 404. Khi do bo class
   * .has-image de CSS chuyen sang ban dung HTML, khong de trang gio hang lo cai icon
   * anh vo. Su kien `error` cua <img> khong noi bot len nen phai nghe o pha capture.
   * Chi xet dung the anh khoi tin cay: cac logo the trong ban dung HTML cung nam
   * trong o nay, chung loi thi khong duoc keo ca khoi anh xuong theo.
   */
  function onResourceError(event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG') return;
    if (!img.classList || !img.classList.contains('g4t-cart__trust-img')) return;
    var box = img.closest('[data-g4t-trust]');
    if (box) box.classList.remove('has-image');
  }

  /* ------------------------------------------------------------------ wiring */

  document.addEventListener('error', onResourceError, true);
  document.addEventListener('change', onChange);
  // CartMain ban su kien nay ngay sau khi thay xong innerHTML cua section
  document.addEventListener('cart:main:render', startClock);
  startClock();
})();
